import { render, staticRenderFns } from "./createReferrerDialog.vue?vue&type=template&id=099d6f80&scoped=true&"
import script from "./createReferrerDialog.vue?vue&type=script&lang=js&"
export * from "./createReferrerDialog.vue?vue&type=script&lang=js&"
import style0 from "./createReferrerDialog.vue?vue&type=style&index=0&id=099d6f80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099d6f80",
  null
  
)

export default component.exports